// The side-filter form the mobile drawer, pills and counts all read from.
export const SIDE_FILTER_SELECTOR = "form[data-controller='side-filter']"

// Order-independent key for a set of medium slugs, used to compare a category's
// mediums against the current selection.
export const slugKey = (slugs) => [...slugs].sort().join(",")

export const checkedMediumKey = (form) =>
  slugKey([...form.querySelectorAll('input[name="medium[]"]:checked')].map((input) => input.value))
